import React, { MouseEvent } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Container, Breadcrumb, Grid, Header, Button, Icon, Segment, Form, Input, Checkbox } from 'semantic-ui-react';
import { useEditHomepageSectionForm } from './useEditHomepageSectionForm';
import { IconSelector } from './IconSelector';
import { convertToRaw } from 'draft-js';
import NewCommonRichEditor from '../../Common/CommonComponents/NewCommonRichEditor';


export function EditHomepageSectionForm() {
    const history = useHistory();

    let params: any = useParams<{ sectionId: string }>();
    let sectionId: number = parseInt(params.sectionId);
    const isCreate: boolean = sectionId === 0;

    const [values, masterData, errors, touched, isLoading, isSubmitting, isValid, errorMessage, registerRef, handleChange, handleBlur, handleSubmit, handleDelete] = useEditHomepageSectionForm(isCreate);

    return <Container className='providers-container'>
        <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>{isCreate ? 'Create' : 'Edit'} Home Page Section</Header>
        <hr style={{ marginBottom: '1.0rem' }} />
        <Breadcrumb style={{ marginBottom: '1.0rem' }}>
            <Breadcrumb.Section link><Link to='/dashboard'>Home</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section link><Link to={'/manageHomepageSections'}>Manage Home Page Sections</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>{isCreate ? 'Create' : 'Edit'} Home Page Section</Breadcrumb.Section>
        </Breadcrumb>
        <Grid columns={1}>
            <Grid.Column>
                <Form loading={isLoading}>
                    <Form.Input
                        className={!(!errors.title || !touched.title) ? 'mb-0' : ''}
                        required
                        fluid
                        label='Title'
                        value={values.title}
                        onChange={(event, data) => {
                            handleChange(data.value, 'title');
                        }}
                        onBlur={
                            () => { handleBlur('title'); }
                        }
                        error={!(!errors.title || !touched.title) ? true : false}
                    />
                    {
                        !(!errors.title || !touched.title) &&
                        <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.title}</div>
                    }
                    <Form.Input className={!(!errors.teaserText || !touched.teaserText) ? 'mb-0' : ''}
                        required
                        fluid
                        label='Teaser Text'
                        value={values.teaserText}
                        onChange={(event, data) => {
                            handleChange(data.value, 'teaserText');
                        }}
                        onBlur={
                            () => { handleBlur('teaserText'); }
                        }
                        error={!(!errors.teaserText || !touched.teaserText) ? true : false}

                    />
                    {
                        !(!errors.teaserText || !touched.teaserText) &&
                        <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.teaserText}</div>
                    }

                    <Form.Field>
                        <label>Icon Name <span style={{ color: 'red' }}>*</span></label>
                        <IconSelector
                            onChange={(selectedIconName: string) => {
                                handleChange(selectedIconName, 'iconName');
                            }}
                            value={values.iconName}
                        ></IconSelector>
                        {
                            !(!errors.iconName || !touched.iconName) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.iconName}</div>
                        }
                    </Form.Field>
                    <Form.Field
                        className={!(!errors.backgroundColor || !touched.backgroundColor) ? 'mb-0' : ''}
                        style={{ width: '15rem' }}
                        label='Background Color'
                        control='input'
                        type='color'
                        name='colorPicker'
                        onChange={(event: any) => {
                            handleChange(event.target.value, 'backgroundColor');
                        }}
                        value={values.backgroundColor}
                        onBlur={
                            () => { handleBlur('backgroundColor') }
                        }
                    ></Form.Field>
                    {
                        !(!errors.backgroundColor || !touched.backgroundColor) &&
                        <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.backgroundColor}</div>
                    }
                    <Form.Field>
                        <b>Selected content type:</b>
                    </Form.Field>
                    <Form.Field>
                        <Checkbox
                            radio
                            label='HTML content'
                            name='checkboxRadioGroup'
                            value={'true'}
                            checked={values.isHtmlContent === true}
                            onChange={(e, { value }) => {
                                handleChange(value === 'true', 'isHtmlContent');
                            }}
                        />
                    </Form.Field>
                    <Form.Field>
                        <Checkbox
                            radio
                            label='URL'
                            name='checkboxRadioGroup'
                            value={'false'}
                            checked={values.isHtmlContent === false}
                            onChange={(e, { value }) => {
                                handleChange(value === 'true', 'isHtmlContent');
                            }}
                        />
                    </Form.Field>
                    {
                        values.isHtmlContent === true &&
                        <>
                            <Form.Field>
                                <label>Page Content</label>
                                <NewCommonRichEditor
                                    value={values.pageContent || ''}
                                    onChange = {(newValue:string)=>{
                                        handleChange(newValue, 'pageContent');
                                    }}
                                    handleonBlur={(event: any, editorState: any, rawContent: any) => {
                                        handleBlur('pageContent');
                                    }}
                                />
                            </Form.Field>

                            <Form.Field>
                                <label>Url <span style={{ color: 'red' }}>*</span></label>
                            </Form.Field>
                            <Form.Field inline className={!(!errors.url || !touched.url) ? 'error' : ''}>
                                <label>https://{document.location.hostname}{process.env.REACT_APP_VIRTUAL_DIRECTORY}/pages/</label>
                                <Input className={!(!errors.url || !touched.url) ? 'mb-0' : ''}
                                    required
                                    value={values.url}
                                    onChange={(event, data) => {
                                        handleChange(data.value, 'url');
                                    }}
                                    onBlur={
                                        () => { handleBlur('url') }
                                    }
                                    error={!(!errors.url || !touched.url) ? true : false}
                                />
                                {
                                    !(!errors.url || !touched.url) &&
                                    <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.url}</div>
                                }
                            </Form.Field>
                        </>
                    }
                    {
                        values.isHtmlContent === false &&
                        <>
                            <Form.Field>
                                <label>Url <span style={{ color: 'red' }}>*</span></label>
                            </Form.Field>
                            <Form.Field inline className={!(!errors.url || !touched.url) ? 'error' : ''}>
                                <label>https://{document.location.hostname}{process.env.REACT_APP_VIRTUAL_DIRECTORY}/</label>
                                <Input className={!(!errors.url || !touched.url) ? 'mb-0' : ''}
                                    required
                                    value={values.url}
                                    onChange={(event, data) => {
                                        handleChange(data.value, 'url');
                                    }}
                                    onBlur={
                                        () => { handleBlur('url') }
                                    }
                                    error={!(!errors.url || !touched.url) ? true : false}
                                />
                                {
                                    !(!errors.url || !touched.url) &&
                                    <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.url}</div>
                                }
                            </Form.Field>
                        </>
                    }



                    <Button type='button' primary onClick={handleSubmit}>{isCreate ? "Create" : "Save"}</Button>
                    {
                        !isCreate &&
                        <Button type='button' style={{backgroundColor:'#db2828', color:'white'}} onClick={handleDelete}>{'Delete'}</Button>
                    }
                    <Button type='button' onClick={() => { history.goBack() }}>Cancel</Button>
                </Form>
            </Grid.Column>
        </Grid>

    </Container>
}